import React from "react";
import PropTypes from "prop-types";
import {Trans, withNamespaces} from "react-i18next";
import styles from "../RouteRow/RouteRow.scss";
import {getFormattedPrice} from "../../bl/routeRowService";
import RouteRoadName from "../RouteRoadName";

const RoutePlaton = ({platonCost, t, roadNames}) => {
  return (<div className={styles.platon}>
    <div title={t("trace-route-region-platon-fee-tooltip", "Плата за участок")} className={styles.platonText}>
      <Trans i18nKey="trace-route-region-platon-fee">{{regionPrice: getFormattedPrice(platonCost)}} за
        Платон</Trans>
    </div>
    <div style={{flexGrow: 2}}></div>
    <div className={styles.roadNamesContainer}>
      {roadNames.map(roadName => (<RouteRoadName key={roadName} roadName={roadName}/>))}
    </div>
  </div>);
};

RoutePlaton.propTypes = {
  platonCost: PropTypes.number.isRequired, roadNames: PropTypes.array.isRequired, t: PropTypes.func.isRequired,
};

export default withNamespaces()(RoutePlaton);
